import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25 } from '@sm360/widget-commons-vehicle';
import 'payment-calculator-v25/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlHeader.scss';

const PurchaseMethodsTabControlHeader = ({
    leaseAvailable,
    leaseSelected,
    financeAvailable,
    financeSelected,
    cashPurchaseSelected,
    selectPurchaseMethod,
}) => {
    const { useEffect, useState } = React;
    const [purchaseMethodLabels, setPurchaseMethodLabels] = useState([]);
    const updatePurchaseMethodLabels = (updateCashPurchaseSelected, updateFinanceSelected, updateLeaseSelected) => {
        const arrPurchaseMethodLabels = [
            {
                name: LocaleService.t('PAYMENT_CALCULATOR_V25.PURCHASEMETHODS.CASH_PURCHASE'),
                type: PurchaseMethodsV25.PurchaseMethodsConstantV25.CASH,
                selected: updateCashPurchaseSelected,
            },
        ];
        if (financeAvailable) {
            arrPurchaseMethodLabels.unshift({
                name: LocaleService.t('PAYMENT_CALCULATOR_V25.PURCHASEMETHODS.FINANCE'),
                type: PurchaseMethodsV25.PurchaseMethodsConstantV25.FINANCE,
                selected: updateFinanceSelected,
            });
        }
        if (leaseAvailable) {
            arrPurchaseMethodLabels.unshift({
                name: LocaleService.t('PAYMENT_CALCULATOR_V25.PURCHASEMETHODS.LEASE'),
                type: PurchaseMethodsV25.PurchaseMethodsConstantV25.LEASE,
                selected: updateLeaseSelected,
            });
        }
        return arrPurchaseMethodLabels;
    };
    useEffect(
        () => {
            setPurchaseMethodLabels(updatePurchaseMethodLabels(cashPurchaseSelected, financeSelected, leaseSelected));
        },
        [leaseSelected, financeSelected, cashPurchaseSelected, financeAvailable, leaseAvailable]
    );
    return (
        <section className="purchase-methods-tab">
            <nav className="purchase-methods-tab__tabs sr-calculator-tabs">
                <ul>
                    {purchaseMethodLabels.map((method) => {
                        return (
                            <li key={method.type} className={method.selected ? 'current' : ''}>
                                <button onClick={() => selectPurchaseMethod(method.type)}>{method.name}</button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </section>
    );
};

PurchaseMethodsTabControlHeader.propTypes = {
    leaseAvailable: PropTypes.bool.isRequired,
    leaseSelected: PropTypes.bool.isRequired,
    financeAvailable: PropTypes.bool.isRequired,
    financeSelected: PropTypes.bool.isRequired,
    cashPurchaseSelected: PropTypes.bool.isRequired,
    selectPurchaseMethod: PropTypes.func.isRequired,
};

PurchaseMethodsTabControlHeader.displayName = 'PurchaseMethodsTabControlHeader';

export default PurchaseMethodsTabControlHeader;
